exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#facet-placeholder {\n  position: absolute;\n  height: 100%;\n  max-height: 100%;\n  width: 30%;\n  left: 0;\n  top: 0;\n  background-color: rgba(52, 112, 101, 0.05);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-color: grey;\n  overflow-y: auto;\n  /*resize: horizontal;\r\n  overflow: auto;*/\n}\n.trajectories-banner {\n  width: 100%;\n}\n.trajectories-text {\n  font-size: 12px;\n  font-weight: bold;\n}\n", ""]);

// exports
